import { ShowInactiveService } from '../../../base/shared/grid-base/show-inactive.service';
import { FilterOperator } from './../../../base/models/models.swagger.generated';
import { IAdaptorService } from './../../../base/shared/syncfusion/adaptor-service.interface';
import {
  ParkerCompanyDTO,
  ParkerCompanyClient,
  CreateParkerCompanyDTO,
  UpdateParkerCompanyDTO,
  PagedResultDTOOfParkerCompanyDTO,
  SortDirection,
  FilterDTO
} from 'src/app/base/models/models.swagger.generated';
import { Observable, of, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastService } from 'src/app/base/services/toast.service';
import { tap, catchError } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ClientService } from 'src/app/base/services/client/client.service';

@Injectable()
export class CompanyAdministrationService extends ShowInactiveService implements IAdaptorService{
  constructor(
    private clientService: ClientService,
    private parkerCompanyClient: ParkerCompanyClient,
    private toastService: ToastService) {
      super();
    }

  // eslint-disable-next-line max-len
  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfParkerCompanyDTO> {
    if (!this.clientService.selectedClient) {
      return of(null);
    }
    if (!sortBy) {
      sortBy = 'Name';
    }
    if (!this.showInactive) {
      if (!filters) {
        filters = [];
      }
      filters.push(new FilterDTO({isComplex: false, field: 'Active', operator: FilterOperator.Equal, value: 'true'}));
    }
    return this.parkerCompanyClient.searchParkerCompanies(this.clientService.selectedClient.id, filters, skip, take, sortBy, sortDirection);
  }

  public addRecord(data: CreateParkerCompanyDTO): Observable<ParkerCompanyDTO> {
    data.clientId = this.clientService.selectedClient?.id;
    return this.parkerCompanyClient.createParkerCompany(data).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.company-administration.messages.add-title',
          'i18n.domain.company-administration.messages.add-success-message'
        );
      }),
      catchError((error) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      }));
  }

  public updateRecord(data: UpdateParkerCompanyDTO): Observable<ParkerCompanyDTO> {
    return this.parkerCompanyClient.updateParkerCompany(data).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.company-administration.messages.update-title',
          'i18n.domain.company-administration.messages.update-success-message'
        );
      }),
      catchError(error => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      }));
  }

  public deleteRecord(id: number): Observable<void> {
    return this.parkerCompanyClient.deleteParkerCompany(id).pipe(
      tap(() => {
        this.toastService.showSuccess(
          'i18n.domain.company-administration.messages.delete-title',
          'i18n.domain.company-administration.messages.delete-success-message'
        );
      }),
      catchError(error => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }
}
